// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".linkify {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  max-width: 80%;\n}\n\n.linkify-body {\n  width: 100%;\n  font-size: 15px;\n  color: #42424a;\n  line-height: 1.4;\n  word-wrap: break-word;\n  white-space: pre-wrap;\n}\n\n.linkify-half-opacity {\n  opacity: 0.5;\n}\n\n.body-emojies-only {\n  width: 100%;\n  font-size: 32px;\n  letter-spacing: 0.09375em;\n  line-height: 1.4;\n  word-wrap: break-word;\n  white-space: pre-line;\n}", ""]);
// Exports
module.exports = exports;
